exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-page canvas{margin:0!important}.sb-page .sb-page-image-container img.sb-page-image{width:100%;height:auto}.sb-page .md-button{margin:6px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/page/page.scss
// module id = 591
// module chunks = 0